import { render } from "./PermissionView.vue?vue&type=template&id=45ecd48a&scoped=true"
import script from "./PermissionView.vue?vue&type=script&lang=js"
export * from "./PermissionView.vue?vue&type=script&lang=js"

import "./PermissionView.vue?vue&type=style&index=0&id=45ecd48a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ecd48a"]])

export default __exports__